import { render, staticRenderFns } from "./FailureComponent.vue?vue&type=template&id=59745808&"
import script from "./FailureComponent.vue?vue&type=script&lang=js&"
export * from "./FailureComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports